import { productAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

export default {
  async fetchProduct({ commit }, productNo) {
    const { data } = await ServiceExec.get(
      productAPI.product_detail(productNo)
    );
    commit('setProduct', data);
    return data;
  },

  async fetchProducts({ state, commit }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(productAPI.search_products, {
      page,
      ...payload
    });

    if (status !== 200) return;
    const { list, pageInfo } = data;

    // commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  }
};
